import $ from 'jquery';
// import mpro from './mpro.init';

// Custom console coloring
mpro.consoleStyle = 'background: #000; color: #FFF; border: 1px solid #FFF;';

// =========
// Sanitizer
// =========

mpro.Sanitize = {

	/**
	 * @param {string} str
	 */
	attr: str => str
		.replaceAll('\'', '&#039;')
		.replaceAll('"', '&quot;')
		.replaceAll('<', '&lt;')
		.replaceAll('>', '&gt;')
		.replaceAll(String.raw`\t`, ' ')
		.replaceAll(String.raw`\r\n`, ' ')
		.replaceAll(String.raw`\n`, ' ')
		.replaceAll(String.raw`\x00`, ' '),

	/**
	 * @param {string} str
	 */
	// @ts-ignore
	html: str => document.createElement('div').appendChild(document.createTextNode(str)).parentNode.innerHTML,

	/**
	 * @param {string} str
	 */
	// @ts-ignore
	htmlDecode: (str) => {
		const textarea = document.createElement('textarea');
		textarea.innerHTML = str;
		return textarea.value;
	},

	/**
	 * @param {string} markup
	 */
	escapeMarkup: (markup) => {

		// Do not try to escape the markup if it's not a string
		if (typeof markup !== 'string') {
			return markup;
		}

		const replaceMap = {
			'\\': '&#92;',
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'"': '&quot;',
			'\'': '&#39;',
			'/': '&#47;',
		};

		return String(markup).replaceAll(/["&'/<>\\]/g, (match) => {
			return replaceMap[match];
		});
	},

	/**
	 * @param {string} markup
	 */
	encodeUri: (markup) => {
		// Do not try to escape the markup if it's not a string
		if (typeof markup !== 'string') {
			return markup;
		}

		const replaceMap = {
			'%': '%25',
			'&': '%26',
			'#': '%23',
			'"': '%22',
			'\'': '%27',
		};

		return String(markup).replaceAll(/["#%&']/g, (match) => {
			return replaceMap[match];
		});
	},

	/**
	 * @param {string} str
	 */
	stripTags: (str) => {
		return str.replaceAll(/(?:<[^>]+>)/g, '');
	},
};

// Other utilities

mpro.reQuote = function(str) {
	return str.replaceAll(/([$()*+./?[\\\]^{|}])/g, String.raw`\$1`);
};

/**
 * @param {string} str
 */
mpro.camelize = (str) => {
	return str.replaceAll(/-([a-z])/g, (_all, letter) => {
		return letter.toUpperCase();
	});
};

mpro.upperFirst = str => str.charAt(0).toUpperCase() + str.slice(1);

mpro.uniqId = function(moreEntropy = false) {
	if (moreEntropy) {
		const c = 'abcdefghijklmnopqrstuvwxyz';
		return c[Math.floor(Math.random() * c.length)] + ((Date.now() + Math.random()) / Math.random() * 10_000).toString(36).replaceAll('.', '');
	}
	return (Date.now() + Math.random()).toString(36).replaceAll('.', '');
};

/**
 * @param {string} uuid
 */
mpro.isValidUuid = uuid => /^[\da-f]{8}-[\da-f]{4}-[0-5][\da-f]{3}-[089ab][\da-f]{3}-[\da-f]{12}$/i.test(uuid);

/**
 * Convert human readable file size (e.g. "10K" or "3Mb") into bytes
 *
 * @param  {string|number} str
 */
mpro.humanReadableToBytes = (str) => {

	// Already a number
	if (typeof str === 'number') {
		return str;
	}
	else if (typeof str !== 'string') {
		return 0;
	}

	const val = str.trim();
	let bytes = Number.parseFloat(val);
	const unit = val.slice(bytes.toString().length).toLowerCase();

	switch (unit) {
		case 'g':
		// @ts-expect-error: Fallthrough case in switch.ts(7029)
		case 'gb': {
			bytes *= 1024;
			// no break
		}
		// eslint-disable-next-line no-fallthrough
		case 'm':
		// @ts-expect-error: Fallthrough case in switch.ts(7029)
		case 'mb': {
			bytes *= 1024;
			// no break
		}
		// eslint-disable-next-line no-fallthrough
		case 'k':
		// @ts-expect-error: Fallthrough case in switch.ts(7029)
		case 'kb': {
			bytes *= 1024;
			// no break
		}
		// eslint-disable-next-line no-fallthrough
		case 'b': {
			break;
		}
		default: {
			if (unit) {
				throw new Error(`Invalid file size unit: ${unit}`);
			}
		}
	}

	return Math.round(bytes);
};

mpro.diffKey = function(o1, o2) {
	const diff = {};
	for (const s1 in o1) {
		if (!(s1 in o2)) {
			diff[s1] = o1[s1];
		}
	}
	return diff;
};

mpro.intersectKey = function(o1, o2) {
	const inter = {};
	for (const s1 in o1) {
		if (s1 in o2) {
			inter[s1] = o1[s1];
		}
	}
	return inter;
};

mpro.arrDiff = function(a, b) {
	const diff = [];
	for (let i = 0, l = a.length; i < l; ++i) {
		if (!(b.includes(a[i]))) {
			diff.push(a[i]);
		}
	}
	return diff;
};

mpro.arrIntersect = function(a, b) {
	const inter = [];
	for (let i = 0, l = a.length; i < l; ++i) {
		if (b.includes(a[i])) {
			inter.push(a[i]);
		}
	}
	return inter;
};

/**
 * @param {{ x: number; w: number; y: number; h: number; }} r1
 * @param {{ x: number; w: number; y: number; h: number; }} r2
 */
mpro.rectIntersects = function(r1, r2) {
	return !(r2.x > r1.x + r1.w ||
		r2.x + r2.w < r1.x ||
		r2.y > r1.y + r1.h ||
		r2.y + r2.h < r1.y
	);
};

/**
 * Add / Update a key-value pair in the URL query parameters
 *
 * @param {string} uri
 * @param {string|{[key: string]: any}} urlParams
 * @param {string} optVal
 */
mpro.updateUrlParams = function(uri, urlParams, optVal) {

	// Remove the hash part before operating on the uri
	const i = uri.indexOf('#');
	const hash = (i === -1) ? '' : uri.slice(i);
	uri = (i === -1) ? uri : uri.slice(0, i);
	const url = new URL(uri, document.URL);

	// Single key/value
	if (typeof urlParams === 'string') {
		const key = urlParams;
		urlParams = {};
		urlParams[key] = optVal;
	}

	for (const name of Object.keys(urlParams)) {
		const val = urlParams[name];
		if (val !== false && val !== '' && val != null) {
			url.searchParams.set(name, val);
		}
		else {
			url.searchParams.delete(name);
		}
	}

	// finally append the hash as well
	return url.toString() + hash;
};

// Change the mode for the current image path
mpro.changeImageMode = function(oldPath, newMode) {
	if (/\/([lmt])_nophoto_/.test(oldPath)) {
		// Rewrite nophoto path
		return oldPath.replace(/(\/)([lmt])(_nophoto_)/, `$1${newMode}$3`);
	}

	return oldPath.replace(/(\/\d{9}\/p\/)([lmt])(\/\d\/)/, `$1${newMode}$3`);

};

/**
 * Prevent scroll when search is expanded
 */
mpro.preventScroll = () => {
	if (window.matchMedia('(max-width: 992px)').matches) {
		!document.body.classList.contains('prevent-scroll') && document.body.classList.add('prevent-scroll');
	}
};

/**
 * Allow scroll when search is expanded
 */
mpro.allowScroll = () => {
	document.body.classList.contains('prevent-scroll') && document.body.classList.remove('prevent-scroll');
};

const setVH = function() {
	document.documentElement.style.setProperty('--vh', `${Number.parseFloat((mpro.viewport().height * 0.01).toFixed(2))}px`);
};

/**
 * VH iPhone fix
 */
mpro.fixVH = () => {
	setVH();
	window.addEventListener('resize', setVH, { passive: true });
};

/**
 * @param {'default' | 'canonical' | 'iso_code'} format
 */
mpro.getCurrentLocale = (format = 'default') => {
	const { language } = mpro.config.env;

	// en-US
	if (format === 'canonical') {
		return language.canonical_locale;
	}
	// en
	else if (format === 'iso_code') {
		return language.iso_code;
	}

	// en_US
	return language.lang_locale;
};

mpro.getCurrentTimezone = () => {
	return mpro.config.env.timezone;
};

/**
 * @param {string} locale
 */
mpro.getDateTimeFormatParts = (locale = 'default') => new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'numeric', day: 'numeric' })
	.formatToParts(Date.UTC(2000, 0, 1));

/**
 * Return the date format string for a given locale
 *
 * @param {string|object} localeOrParts
 * @param {{ maskCompatible?: boolean; mask?: boolean; }} options
 */
mpro.getDateFormat = (localeOrParts, options = {}) => {
	const { mask, maskCompatible } = options;
	return ((typeof localeOrParts === 'string') ? mpro.getDateTimeFormatParts(localeOrParts) : localeOrParts)
		.map(({ type, value }) => {
			switch (type) {
				case 'year': {
					return (mask ? '0' : 'Y').repeat(maskCompatible ? 4 : value.length);
				}
				case 'month': {
					return (mask ? '0' : 'M').repeat(maskCompatible ? 2 : value.length);
				}
				case 'day': {
					return (mask ? '0' : 'D').repeat(maskCompatible ? 2 : value.length);
				}
				// eslint-disable-next-line unicorn/no-useless-switch-case
				case 'literal':
				default: {
					return value;
				}
			}
		}).join('');
};

const dateFormatters = Object.create(null);
const dateTimeFormatters = Object.create(null);

/**
 * @param {'long' | 'short' | 'full' | 'medium'} dateStyle
 */
mpro.getDateFormatter = (dateStyle = 'short') => {
	if (!dateFormatters[dateStyle]) {
		const { language: { canonical_locale: locale }, timezone: timeZone } = mpro.config.env;
		dateFormatters[dateStyle] = new Intl.DateTimeFormat(locale, {
			dateStyle,
			timeZone,
		});
	}
	return dateFormatters[dateStyle];
};

/**
 * @param {'long' | 'short' | 'full' | 'medium'} dateStyle
 */
mpro.getDateTimeFormatter = (dateStyle = 'short', timeStyle = 'short') => {
	if (!dateTimeFormatters[dateStyle]) {
		const { language: { canonical_locale: locale }, timezone: timeZone } = mpro.config.env;
		dateTimeFormatters[dateStyle] = new Intl.DateTimeFormat(locale, {
			dateStyle,
			timeZone,
			timeStyle
		});
	}
	return dateTimeFormatters[dateStyle];
};

mpro.formatDateForModel = (date) => {
	const parts = mpro.getDateFormatter().formatToParts(date);
	const map = {};

	for (const part of parts) {
		map[part.type] = part.value;
	}

	return `${map.year}-${map.month}-${map.day}`;
};

mpro.formatDateForView = (date) => {
	return mpro.getDateFormatter().format(date);
};

/**
 * @param {string} selector
 * @param {string} urlAttr
 * @param {string=} targetAttr
 */
mpro.handleClickRedirect = (selector, urlAttr, targetAttr) => {

	// Attach delegate listener on the top-most element
	mpro.get$D().on('click.handleClickRedirect', selector, function(e) {

		// Skip redirect on containing links and buttons
		if (e.target !== e.currentTarget && (e.target.nodeName === 'A' || e.target.nodeName === 'BUTTON')) {
			return;
		}

		e.preventDefault();
		e.stopImmediatePropagation();
		e.stopPropagation();

		// Get location from metadata
		const $element = $(this);
		const location = $element.attr(urlAttr);
		const target = $element.attr(targetAttr || 'target') || '_self';

		// We have a location
		if (typeof location === 'string') {
			if (target === '_blank') {
				mpro.openLinkInNewWindow(location);
				return;
			}
			// Do redirect in ajax-navigation or fallback on window.location
			mpro.setLocation(location, { el: this });
		}
	});
};

/**
 * @param {string} selector
 */
mpro.handleUrlReturn = (selector) => {

	// Attach delegate listener on the top-most element
	mpro.get$D().on('click.handleUrlReturn', selector, function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		e.stopPropagation();

		// Get location from metadata
		const $element = $(this);
		const target = $element.attr('target') || '_self';
		const href = $element.attr('href');

		// We have a location
		if (typeof href === 'string') {
			// Create URL object for the clicked link
			const url = new URL(href, window.location.origin); // href should be absolute or relative to current location
			
			// Create URL object for the current location (return URL)
			const returnUrl = new URL(window.location.href);

			// Delete the 'sections' query parameter if it exists
			returnUrl.searchParams.delete('sections');

			// Add the 'return' parameter to the clicked link URL
			const returnPath = returnUrl.pathname + (returnUrl.search ? `?${returnUrl.searchParams}` : '');
			url.searchParams.set('return', returnPath);

			const location = url.toString();

			if (target === '_blank') {
				mpro.openLinkInNewWindow(location);
				return;
			}
			// Do redirect in ajax-navigation or fallback on window.location
			mpro.setLocation(location, { el: this });
		}
	});
};

/**
 * @param {string} url
 */
mpro.openLinkInNewWindow = (url) => {

	const urlObj = new URL(url, window.location.origin);
	const { body } = document;
	const form = document.createElement('form');

	// Extract query parameters and add them as hidden inputs
	for (const [key, value] of urlObj.searchParams.entries()) {
		const input = document.createElement('input');
		input.setAttribute('type', 'hidden');
		input.setAttribute('name', key);
		input.setAttribute('value', value);
		form.append(input);
	}

	body.append(form);
	form.method = 'get';
	form.target = '_blank';
	form.action = urlObj.origin + urlObj.pathname;
	form.submit();
	form.remove();
};

/**
 * Use this method instead of the location.href/location.assign setter (extended with ajax navigation when enabled)
 *
 * @param {string} url
 * @param {SetLocationOptions?} options
 */
mpro.setLocation = window.setLocation = function(url, options = {}) {

	// Display the loader (without animation)
	// !Note: do not use any kind of loader because we cannot accurately determine when the page is replaced (for example when receiving a location link that only downloads a file)
	// mpro.addContentLoader(mpro.get$B(), options.loaderClasses || ['none', 'transparent'], options.loaderOptions || {});

	// Remove the loader when the browser page comes back BFCache
	// mpro.oncePageRestore(() => void mpro.removeContentLoader(mpro.get$B()));

	// Don't add to history stack
	if (options.replace) {
		return window.location.replace(url);
	}
	return (window.location.href = url);
};

export default mpro;
